import { LexicalComposer as CompLexicalComposer } from '@lexical/react/LexicalComposer';
import LexicalErrorBoundary from '@lexical/react/LexicalErrorBoundary.js';
import { HistoryPlugin } from '@lexical/react/LexicalHistoryPlugin.js';
import { OnChangePlugin } from '@lexical/react/LexicalOnChangePlugin.js';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import { memo } from 'react';
import AutoFocusPlugin from './AutoFocusPlugin.jsx';
import BlockPlugin from './BlockPlugin.jsx';
import KeyInterceptPlugin from './KeyInterceptPlugin.jsx';
import SelectionStatePlugin from './SelectionStatePlugin.jsx';
import { ContentEditable } from '@lexical/react/LexicalContentEditable.js';
import LexicalPlaceholder from './LexicalPlaceholder.jsx';

const MemoHistoryPlugin = memo(() => <HistoryPlugin />);
const MemoOnChangePlugin = memo(({ onChange }) => <OnChangePlugin onChange={onChange} />);
const MemoContentEditable = memo(({ className, style, onFocus, onKeyDown, onKeyPress }) => <ContentEditable className={className} style={style} onFocus={onFocus} onKeyDown={onKeyDown} onKeyPress={onKeyPress} />);
const MemoPlaceholder = memo(({ id, placeholder }) => <LexicalPlaceholder id={id} placeholder={placeholder} />);

const LexicalComposer = memo(({ initialConfig, id, placeholder, inputStyle, autoFocus, handleChange, handleFocus, handleKeyDown, handleKeyPress }) => {
  return (
    <CompLexicalComposer initialConfig={initialConfig}>
      <RichTextPlugin //
        contentEditable={<MemoContentEditable className={`lexical-input li-${id} input-element`} style={inputStyle} onFocus={handleFocus} onKeyDown={handleKeyDown} onKeyPress={handleKeyPress} />}
        placeholder={<MemoPlaceholder id={id} placeholder={placeholder} />}
        ErrorBoundary={LexicalErrorBoundary}
      />
      <BlockPlugin id={id} />
      <MemoHistoryPlugin />
      <KeyInterceptPlugin />
      <AutoFocusPlugin autoFocus={autoFocus} />
      <SelectionStatePlugin />
      <MemoOnChangePlugin onChange={handleChange} />
    </CompLexicalComposer>
  );
});

LexicalComposer.displayName = 'LexicalComposer';
MemoHistoryPlugin.displayName = 'MemoHistoryPlugin';
MemoOnChangePlugin.displayName = 'MemoOnChangePlugin';
MemoContentEditable.displayName = 'MemoContentEditable';
MemoPlaceholder.displayName = 'MemoPlaceholder';

export default LexicalComposer;
